// @ts-nocheck
import { defineComponent, h } from 'vue'
import { useNamespace } from '@code-monkey-ui/hooks'
import { definePropType } from '@code-monkey-ui/utils'
import { DSH_CASCADER_ALL_NODE_VALUE, DshDefaultProps } from './config'
export default defineComponent({
  name: 'ElDshNodeContent',
  props: {
    onlyCheck: {
      type: definePropType<() => boolean>(Function),
      default: () => {
        // console.log('按钮被点击了')
      },
    },
    node: {
      type: Object as PropType<DshCascaderNode>,
      required: true,
    },
  },
  setup() {
    const ns = useNamespace('dsh-cascader-node')
    return {
      ns,
    }
  },
  render(props) {
    const { ns } = this
    const { node, panel, onlyThis } = this.$parent
    const { data, label } = node
    const { renderLabelFn } = panel
    const value = props.node.config.value ?? DshDefaultProps.value

    return h(
      'span',
      { class: ns.e('label') },
      renderLabelFn
        ? renderLabelFn({ node, data })
        : !onlyThis
        ? label
        : [
            h('div', { class: `${ns.namespace.value}-dsh-justify-between` }, [
              h(
                'span',
                { class: `${ns.namespace.value}-dsh-cascader-node--label` },
                label
              ),
              data[value] !== DSH_CASCADER_ALL_NODE_VALUE
                ? h('div', { class: 'select-tag', onClick: this.onlyCheck }, [
                    h('span', {}, '仅筛选此项'),
                  ])
                : '',
            ]),
          ]
    )
  },
})
